import React from "react";
import { Contact } from "lucide-react";

// ফোনে সেভ করা কন্টাক্ট থেকে নাম ও নম্বর সরাসরি নেওয়া (Android Chrome, HTTPS)।
const supported = () =>
  typeof navigator !== "undefined" && "contacts" in navigator && typeof window !== "undefined" && "ContactsManager" in window;

export default function ContactPicker({ onPick, testid }: { onPick: (c: { name?: string; tel?: string }) => void; testid?: string }) {
  if (!supported()) return null;
  const pick = async () => {
    try {
      const res = await (navigator as any).contacts.select(["name", "tel"], { multiple: false });
      if (res && res.length) {
        const c = res[0];
        const name = Array.isArray(c.name) ? c.name[0] : c.name;
        let tel = Array.isArray(c.tel) ? c.tel[0] : c.tel;
        if (tel) tel = String(tel).replace(/[^\d+]/g, "");
        onPick({ name: name || "", tel: tel || "" });
      }
    } catch {
      /* ব্যবহারকারী বাতিল করেছে বা অনুমতি নেই */
    }
  };
  return (
    <button
      type="button"
      onClick={pick}
      data-testid={testid || "contact-picker-button"}
      title="ফোনের কন্টাক্ট থেকে নিন"
      className="inline-flex items-center gap-1.5 h-10 px-3 rounded-lg bg-blue-50 text-blue-700 border border-blue-200 hover:bg-blue-100 text-sm font-semibold whitespace-nowrap transition-colors active:scale-95"
    >
      <Contact size={16} /> ফোন থেকে
    </button>
  );
}
